"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var BaseFpsControl_1 = require('./BaseFpsControl');
var stream_1 = require('stream');
var PointerStream_1 = require('./PointerStream');
var RotationStream = (function (_super) {
    __extends(RotationStream, _super);
    function RotationStream(state) {
        _super.call(this);
        this.state = state;
        this.state.x_rotation_accum = 0;
        this.state.y_rotation_accum = 0;
    }
    RotationStream.prototype.write = function (changes) {
        this.state.x_rotation_accum -= changes.dy || 0;
        this.state.y_rotation_accum -= changes.dx || 0;
        return true;
    };
    return RotationStream;
}(stream_1.Writable));
exports.RotationStream = RotationStream;
var FpsControl = (function (_super) {
    __extends(FpsControl, _super);
    function FpsControl(state, shell, opts) {
        if (opts === void 0) { opts = {}; }
        _super.call(this, state, opts);
        this.pointerStream = new PointerStream_1.default({ shell: shell });
        this.pointerStream.pipe(this.createWriteRotationStream());
    }
    FpsControl.prototype.createWriteRotationStream = function () {
        return new RotationStream(this.state);
    };
    return FpsControl;
}(BaseFpsControl_1.default));
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = FpsControl;
//# sourceMappingURL=FpsControl.js.map


/*****************
 ** WEBPACK FOOTER
 ** /Users/songseunggeun/voxeline/engine/lib/controls/FpsControl.js
 ** module id = 337
 ** module chunks = 0
 **/